import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorInterceptorService } from '@app/core/interceptors/error-interceptor/services/error-interceptor.service';

export function errorInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const service = inject(ErrorInterceptorService);

  return next(request).pipe(
    catchError((httpErrorResponse: HttpErrorResponse) => {
      if (service.shouldBeIgnored(request, httpErrorResponse)) {
        return throwError(() => httpErrorResponse);
      }

      const status: HttpStatusCode | number = httpErrorResponse.status;

      switch (status) {
        case 0:
        case HttpStatusCode.BadRequest:
        case HttpStatusCode.NotFound:
        case HttpStatusCode.MethodNotAllowed:
        case HttpStatusCode.Conflict:
        case HttpStatusCode.InternalServerError:
        case HttpStatusCode.BadGateway:
        case HttpStatusCode.GatewayTimeout:
        case HttpStatusCode.UnprocessableEntity:
        case HttpStatusCode.ServiceUnavailable:
        case HttpStatusCode.PayloadTooLarge:
          return service.handleDefaultError({
            request,
            next,
            error: httpErrorResponse,
          });

        case HttpStatusCode.Forbidden:
          return service.handleForbiddenError({
            request,
            next,
            error: httpErrorResponse,
          });
      }

      return throwError(() => httpErrorResponse);
    })
  );
}
